var Direction;

(function (Direction) {
  Direction["Forward"] = "FORWARD";
  Direction["Back"] = "BACK";
  Direction["Rest"] = "REST";
})(Direction || (Direction = {}));

export { Direction };
